/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../app/user/user.module';
import * as i2 from './network/network.component.ngfactory';
import * as i3 from './view/view.component.ngfactory';
import * as i4 from './create/newuser.component.ngfactory';
import * as i5 from './user.component.ngfactory';
import * as i6 from './community/people.component.ngfactory';
import * as i7 from './user-claims/user.claims.component.ngfactory';
import * as i8 from './user-character/user.character.component.ngfactory';
import * as i9 from '@angular/common';
import * as i10 from '@angular/platform-browser';
import * as i11 from '@angular/forms';
import * as i12 from 'angular2-recaptcha/lib/captcha.service';
import * as i13 from '../../../app/services/user.service';
import * as i14 from '@angular/http';
import * as i15 from 'ngx-cookie/src/cookie.service';
import * as i16 from 'angulartics2/dist/core/angulartics2';
import * as i17 from '../../../app/services/store.service';
import * as i18 from '../../../app/services/social.service';
import * as i19 from '../../../app/app.pipes';
import * as i20 from 'angular2-masonry/src/module';
import * as i21 from 'angular2-qrcode';
import * as i22 from 'angular2-moment/moment.module';
import * as i23 from 'angular2-recaptcha/angular2-recaptcha';
import * as i24 from 'mydatepicker/dist/my-date-picker.module';
import * as i25 from 'angular2-focus';
import * as i26 from 'angular2-froala-wysiwyg/editor/editor.module';
import * as i27 from 'angular2-froala-wysiwyg/view/view.module';
import * as i28 from '@angular/router';
import * as i29 from '../../../app/user/network/network.component';
import * as i30 from '../../../app/user/view/view.component';
import * as i31 from '../../../app/user/create/newuser.component';
import * as i32 from '../../../app/user/user.component';
import * as i33 from '../../../app/user/community/people.component';
import * as i34 from '../../../app/user/user-claims/user.claims.component';
import * as i35 from '../../../app/user/user-character/user.character.component';
export const UserModuleNgFactory:i0.NgModuleFactory<i1.UserModule> = i0.ɵcmf(i1.UserModule,
    ([] as any[]),(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i2.NetworkComponentNgFactory,i3.ViewComponentNgFactory,i4.NewUserComponentNgFactory,
              i5.UserComponentNgFactory,i6.PeopleComponentNgFactory,i7.UserCliamsComponentNgFactory,
              i8.CharacterComponentNgFactory]],[3,i0.ComponentFactoryResolver],i0.NgModuleRef]),
          i0.ɵmpd(5120,i0.LOCALE_ID,i0.ɵm,[[3,i0.LOCALE_ID]]),i0.ɵmpd(4608,i9.NgLocalization,
              i9.NgLocaleLocalization,[i0.LOCALE_ID]),i0.ɵmpd(4608,i0.Compiler,i0.Compiler,
              ([] as any[])),i0.ɵmpd(5120,i0.APP_ID,i0.ɵf,([] as any[])),i0.ɵmpd(5120,
              i0.IterableDiffers,i0.ɵk,([] as any[])),i0.ɵmpd(5120,i0.KeyValueDiffers,
              i0.ɵl,([] as any[])),i0.ɵmpd(4608,i10.DomSanitizer,i10.ɵe,[i9.DOCUMENT]),
          i0.ɵmpd(6144,i0.Sanitizer,(null as any),[i10.DomSanitizer]),i0.ɵmpd(4608,
              i10.HAMMER_GESTURE_CONFIG,i10.HammerGestureConfig,([] as any[])),i0.ɵmpd(5120,
              i10.EVENT_MANAGER_PLUGINS,(p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
                return [new i10.ɵDomEventsPlugin(p0_0),new i10.ɵKeyEventsPlugin(p1_0),
                    new i10.ɵHammerGesturesPlugin(p2_0,p2_1)];
              },[i9.DOCUMENT,i9.DOCUMENT,i9.DOCUMENT,i10.HAMMER_GESTURE_CONFIG]),i0.ɵmpd(4608,
              i10.EventManager,i10.EventManager,[i10.EVENT_MANAGER_PLUGINS,i0.NgZone]),
          i0.ɵmpd(135680,i10.ɵDomSharedStylesHost,i10.ɵDomSharedStylesHost,[i9.DOCUMENT]),
          i0.ɵmpd(4608,i10.ɵDomRendererFactory2,i10.ɵDomRendererFactory2,[i10.EventManager,
              i10.ɵDomSharedStylesHost]),i0.ɵmpd(6144,i0.RendererFactory2,(null as any),
              [i10.ɵDomRendererFactory2]),i0.ɵmpd(6144,i10.ɵSharedStylesHost,(null as any),
              [i10.ɵDomSharedStylesHost]),i0.ɵmpd(4608,i0.Testability,i0.Testability,
              [i0.NgZone]),i0.ɵmpd(4608,i10.Meta,i10.Meta,[i9.DOCUMENT]),i0.ɵmpd(4608,
              i10.Title,i10.Title,[i9.DOCUMENT]),i0.ɵmpd(4608,i11.ɵi,i11.ɵi,([] as any[])),
          i0.ɵmpd(5120,i12.ReCaptchaService,i12.RECAPTCHA_SERVICE_PROVIDER_FACTORY,
              [i0.NgZone,[3,i12.ReCaptchaService]]),i0.ɵmpd(4608,i13.UserService,i13.UserService,
              [i14.Http,i15.CookieService,i16.Angulartics2]),i0.ɵmpd(4608,i17.StoreService,
              i17.StoreService,[i14.Http,i15.CookieService,i13.UserService,i16.Angulartics2]),
          i0.ɵmpd(4608,i18.SocialService,i18.SocialService,[i14.Http,i13.UserService,
              i15.CookieService,i16.Angulartics2]),i0.ɵmpd(512,i9.CommonModule,i9.CommonModule,
              ([] as any[])),i0.ɵmpd(512,i19.MainPipeModule,i19.MainPipeModule,([] as any[])),
          i0.ɵmpd(1024,i0.ErrorHandler,i10.ɵa,([] as any[])),i0.ɵmpd(1024,i0.APP_INITIALIZER,
              (p0_0:any,p0_1:any) => {
                return [i10.ɵc(p0_0,p0_1)];
              },[[2,i10.NgProbeToken],[2,i0.NgProbeToken]]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i10.BrowserModule,i10.BrowserModule,[[3,i10.BrowserModule]]),
          i0.ɵmpd(512,i11.ɵba,i11.ɵba,([] as any[])),i0.ɵmpd(512,i11.FormsModule,i11.FormsModule,
              ([] as any[])),i0.ɵmpd(512,i20.MasonryModule,i20.MasonryModule,([] as any[])),
          i0.ɵmpd(512,i21.QRCodeModule,i21.QRCodeModule,([] as any[])),i0.ɵmpd(512,
              i22.MomentModule,i22.MomentModule,([] as any[])),i0.ɵmpd(512,i23.ReCaptchaModule,
              i23.ReCaptchaModule,([] as any[])),i0.ɵmpd(512,i24.MyDatePickerModule,
              i24.MyDatePickerModule,([] as any[])),i0.ɵmpd(512,i25.FocusModule,i25.FocusModule,
              ([] as any[])),i0.ɵmpd(512,i26.FroalaEditorModule,i26.FroalaEditorModule,
              ([] as any[])),i0.ɵmpd(512,i27.FroalaViewModule,i27.FroalaViewModule,
              ([] as any[])),i0.ɵmpd(512,i28.RouterModule,i28.RouterModule,[[2,i28.ɵa],
              [2,i28.Router]]),i0.ɵmpd(512,i1.UserModule,i1.UserModule,([] as any[])),
          i0.ɵmpd(1024,i28.ROUTES,() => {
            return [[{path:'network',component:i29.NetworkComponent,data:{title:'Network - Identity RPG'}},
                {path:'id/:id',component:i30.ViewComponent,data:{title:'User - Identity RPG'}},
                {path:'profile/:id',component:i30.ViewComponent,data:{title:'User Profile - Identity RPG'}},
                {path:'account/new',component:i31.NewUserComponent,data:{title:'New Identity - Identity RPG'}},
                {path:'view',component:i32.UserComponent,data:{title:'My Account - Identity RPG'}},
                {path:'account',component:i32.UserComponent,data:{title:'My Account - Identity RPG'}},
                {path:'account/view',component:i32.UserComponent,data:{title:'My Account - Identity RPG'}},
                {path:'account/view/:path',component:i32.UserComponent,data:{title:'My Account - Identity RPG'}},
                {path:'account/people',component:i33.PeopleComponent,data:{title:'Listing Identities - Identity RPG'}},
                {path:'account/claims',component:i34.UserCliamsComponent,data:{title:'Claims - My Account - Identity RPG'}},
                {path:'account/character',component:i35.CharacterComponent,data:{title:'Character Customizer - Identity RPG'}}]];
          },([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvQXN5bHVtL2lkZW50aXR5LXZhZ3JhbnQvc3JjL2FzeWx1bS1pZGVuZXRpdHkvc3JjL2FwcC91c2VyL3VzZXIubW9kdWxlLm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0M6L1VzZXJzL0FzeWx1bS9pZGVudGl0eS12YWdyYW50L3NyYy9hc3lsdW0taWRlbmV0aXR5L3NyYy9hcHAvdXNlci91c2VyLm1vZHVsZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/aot/app/user/user.module.ngfactory.ts